import { QuoteAddress } from "../types"

export const formatAddress = (address: QuoteAddress) => {
  return [address.line1, address.line2, address.town, address.postcode].filter(Boolean).join(", ")
}
